import React from 'react';
import { Lightbulb, Target, Beaker, GitBranch } from 'lucide-react';
export function MethodSection() {
  const steps = [{
    icon: Lightbulb,
    title: '3 Ideas',
    desc: 'Deja de buscar la idea perfecta. Elige 3 opciones viables basadas en lo que ya sabes hacer hoy.'
  }, {
    icon: Target,
    title: '3 Micro-ofertas',
    desc: 'Empaqueta esas ideas en ofertas simples. Sin web, sin logo, solo una promesa clara.'
  }, {
    icon: Beaker,
    title: '3 Micro-tests',
    desc: 'Prueba real con gente real. 10 mensajes, 1 post. Validar sin gastar dinero.'
  }, {
    icon: GitBranch,
    title: '3 Decisiones',
    desc: 'Matar lo que no funciona. Ajustar lo que tiene potencial. Duplicar lo que vende.'
  }];
  return <section className="py-24 bg-white" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <div className="text-center mb-16" data-id="element-113">
          <span className="text-orange-500 font-bold tracking-wider uppercase text-sm" data-id="element-114">
            El Secreto
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mt-2 mb-6" data-id="element-115">
            El Método 3x3
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-116">
            En vez de "soñar" y construir castillos en el aire, generas
            evidencia real. No construyes, <strong data-id="element-117">pruebas</strong>.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-118">
          {/* Connector Line (Desktop) */}
          <div className="hidden lg:block absolute top-12 left-0 w-full h-0.5 bg-gray-100 -z-10 transform translate-y-4" data-id="element-119"></div>

          {steps.map((step, index) => <div key={index} className="bg-white p-6 rounded-xl border border-gray-100 shadow-lg hover:shadow-xl transition-shadow group" data-id="element-120">
              <div className="w-16 h-16 bg-teal-50 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-teal-600 transition-colors duration-300 mx-auto lg:mx-0" data-id="element-121">
                <step.icon className="w-8 h-8 text-teal-600 group-hover:text-white transition-colors duration-300" data-id="element-122" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center lg:text-left" data-id="element-123">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-center lg:text-left" data-id="element-124">
                {step.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-125">
          <div className="inline-block bg-orange-50 border border-orange-100 rounded-lg p-6 max-w-3xl" data-id="element-126">
            <h4 className="text-lg font-bold text-orange-800 mb-2" data-id="element-127">
              ¿Qué cambia cuando usas 3x3?
            </h4>
            <p className="text-orange-900/80" data-id="element-128">
              No te quedas atorada en "¿qué vendo?". No te pierdes en
              herramientas. No esperas sentirte lista. Empiezas pequeño, con
              límites, y te concentras en una sola cosa:{' '}
              <strong data-id="element-129">conseguir tu primer cobro.</strong>
            </p>
          </div>
        </div>
      </div>
    </section>;
}